import React, { useEffect, useState } from "react";
import userResources from "api/userResources";
import { MaterialReactTable } from "material-react-table";

export default function AiCallingData() {
  const [callEnquiry, setCallEnquiry] = useState([]);
  const [loading, setLoading] = useState(true);

  const parseOrderDetails = (str) => {
    try {
      const [
        flightPart,
        airline,
        route,
        datePart,
        passengerPart,
        seatPart,
      ] = str.split(",").map((s) => s.trim());

      const flightNumber = flightPart.replace("Flight ", "");
      const dateMatch = datePart.match(/(\d{4}-\d{2}-\d{2}) to (\d{4}-\d{2}-\d{2})/);
      const passenger = passengerPart.replace("Passenger: ", "");
      const seat = seatPart.replace("Seat: ", "");

      return {
        flightNumber,
        airline,
        route,
        dateFrom: dateMatch?.[1] || "",
        dateTo: dateMatch?.[2] || "",
        passenger,
        seat,
      };
    } catch (err) {
      console.error("Error parsing order details:", err);
      return {};
    }
  };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await userResources.aiCallingEnquirys();
      
      // Parse order_details
      const enrichedData = (response?.data?.data || [])?.map((item) => ({
        ...item,
        order: parseOrderDetails(item.order_details),
      }));
      setCallEnquiry(enrichedData);
    } catch (err) {
      // console.error("Error fetching call enquiries:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    { accessorKey: "id", header: "ID" },
    { accessorKey: "mobile", header: "Mobile" },
    { accessorKey: "order.flightNumber", header: "Flight Number" },
    { accessorKey: "order.airline", header: "Airline" },
    { accessorKey: "order.route", header: "Route", size: 200 },
    { accessorKey: "order.dateFrom", header: "From Date" },
    { accessorKey: "order.dateTo", header: "To Date" },
    { accessorKey: "order.passenger", header: "Passenger" },
    { accessorKey: "order.seat", header: "Seat" },
    { accessorKey: "call_id", header: "Call ID" },
    {
      accessorKey: "created_at",
      header: "Created At",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString(),
    },
  ];

  return (
    <div className="p-4">
      <MaterialReactTable
        columns={columns}
        data={callEnquiry}
        enableColumnFilters
        enableSorting
        enablePagination
        state={{ isLoading: loading }}
        initialState={{ density: "compact" }}
      />
    </div>
  );
}
